import { createSlice } from '@reduxjs/toolkit';

export const navigationControls = createSlice({
  name: 'NAVIGATION_CONTROLS',
  initialState: {}, // state comes from preloadedState in the store and overwrites

  reducers: {
    setPendingMoveForwards(state, action) {
      const { isAwaitingAsyncRequest } = action.payload;
      return {
        ...state,
        pendingMoveForwards: isAwaitingAsyncRequest,
      };
    },

    setPendingMoveBackwards(state, action) {
      const { isAwaitingAsyncRequest } = action.payload;
      return {
        ...state,
        pendingMoveBackwards: isAwaitingAsyncRequest,
      };
    },

    setShouldNavigateForward(state, action) {
      return {
        ...state,
        shouldNavigateForward: action.payload.shouldNavigateForward,
      };
    },

    setShouldNavigateBackward(state, action) {
      return {
        ...state,
        shouldNavigateBackward: action.payload.shouldNavigateBackward,
      };
    },

    setBlockedDestinationPage(state, action) {
      return {
        ...state,
        blockedDestinationPage: action.payload.pageNumber,
      };
    },

    setNavigationBlockOnPage(state, action) {
      const { pageNumber, blockName, isPreventingNavigation } = action.payload;
      const currentBlocks = state.pagesWithNavigationBlocks[pageNumber] || [];
      const existingBlockIndex = currentBlocks.indexOf(blockName);

      return {
        ...state,
        pagesWithNavigationBlocks: {
          ...state.pagesWithNavigationBlocks,
          [pageNumber]: isPreventingNavigation
            ? [...currentBlocks, blockName]
            : [
                ...currentBlocks.slice(0, existingBlockIndex),
                ...currentBlocks.slice(
                  existingBlockIndex + 1,
                  currentBlocks.length
                ),
              ],
        },
      };
    },

    setAttemptToNavigate(state, action) {
      const { attemptToNavigate } = action.payload;
      return {
        ...state,
        attemptToNavigate,
      };
    },

    setPendingExternalSubmit(state, action) {
      const { pendingExternalSubmit } = action.payload;
      return {
        ...state,
        pendingExternalSubmit,
      };
    },
  },
});

const { actions, reducer } = navigationControls;

export const {
  setPendingMoveBackwards,
  setPendingMoveForwards,
  setShouldNavigateForward,
  setShouldNavigateBackward,
  setBlockedDestinationPage,
  setNavigationBlockOnPage,
  setAttemptToNavigate,
  setPendingExternalSubmit,
} = actions;

export default reducer;
